var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { computed, observable } from "mobx";
import * as Models from "../../../../../data/models";
var OpenPulseBetViewModel = /** @class */ (function (_super) {
    __extends(OpenPulseBetViewModel, _super);
    function OpenPulseBetViewModel(stake, gain, pulseBetMetadata, startTimeOfBet, currentGameProgress, purchaseId, hasOddsChangedHandler, betAgainHandler, backToBetPlacementHandler, trackColor, bonusInfo) {
        var _this = _super.call(this, stake, pulseBetMetadata, currentGameProgress) || this;
        _this.trackColor = trackColor;
        _this.gain = gain;
        _this.startTimeOfBet = startTimeOfBet;
        _this.purchaseId = purchaseId;
        _this.isFinished = false;
        _this.hasOddsChangedHandler = hasOddsChangedHandler;
        _this.betAgainHandler = betAgainHandler;
        _this.backToBetPlacementHandler = backToBetPlacementHandler;
        _this.progressInMilli = 0;
        _this.animationStarted = Date.now();
        _this.bonusInfo = bonusInfo;
        return _this;
    }
    Object.defineProperty(OpenPulseBetViewModel.prototype, "formatedGain", {
        get: function () {
            return this.calculatedPeriodHelperDependency.formatWinnings(this.gain);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OpenPulseBetViewModel.prototype, "uniqueKey", {
        get: function () {
            return "purchaseId:" + this.purchaseId + "market:" + this.pulseBetMetadata.marketId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OpenPulseBetViewModel.prototype, "periodFrames", {
        get: function () {
            /* istanbul ignore next */
            var wrappedPeriods = this.calculatedPeriodHelperDependency.wrappedCalculatedPeriods(this.stake, this.pulseBetMetadata);
            return wrappedPeriods.map(function (p) {
                return ({
                    start: p.absoluteToGameFormattedGameStart,
                    end: p.absoluteGameFormattedGameEnd
                });
            });
        },
        enumerable: true,
        configurable: true
    });
    OpenPulseBetViewModel.prototype.isBetExpired = function () {
        var e_1, _a;
        var duration = 0;
        try {
            for (var _b = __values(this.pulseBetProgressData.periods), _c = _b.next(); !_c.done; _c = _b.next()) {
                var period = _c.value;
                duration += period.duration;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        duration *= 1000;
        return this.isFinished || this.pulseBetProgressData.expiredBetProgressInMilliseconds >= duration;
    };
    __decorate([
        observable,
        __metadata("design:type", Models.WinningsDataModel)
    ], OpenPulseBetViewModel.prototype, "winningsData", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], OpenPulseBetViewModel.prototype, "finishedState", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], OpenPulseBetViewModel.prototype, "isFinished", void 0);
    __decorate([
        computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], OpenPulseBetViewModel.prototype, "formatedGain", null);
    __decorate([
        computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], OpenPulseBetViewModel.prototype, "uniqueKey", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], OpenPulseBetViewModel.prototype, "periodFrames", null);
    return OpenPulseBetViewModel;
}(Models.BasicPulseBetViewModel));
export { OpenPulseBetViewModel };
//# sourceMappingURL=OpenPulseBetViewModel.js.map